<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid ? '编辑' : '新建'"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="编号" prop="no">
            <el-input v-model.trim="model.no" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input v-model.trim="model.name" placeholder="请输入名称" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="外部编号">
            <el-input v-model.trim="model.outerNO" placeholder="请输入外部编号" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="简称">
            <el-input v-model.trim="model.shortName" placeholder="请输入简称" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="缩写">
            <el-input v-model.trim="model.shortCode" placeholder="请输入缩写"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人">
            <el-input v-model.trim="model.contact" placeholder="请输入联系人"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系方式">
            <el-input v-model.trim="model.mobile" placeholder="请输入联系方式"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行">
            <el-input v-model.trim="model.bank" placeholder="请输入开户行"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="开户行号">
            <el-input v-model.trim="model.vATNO" placeholder="请输入开户行号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户名">
            <el-input v-model.trim="model.vATNAME" placeholder="请输入开户名"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="收款账号">
            <el-input v-model.trim="model.accounts" placeholder="请输入收款账号"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系地址">
            <el-input v-model="model.address" placeholder="请输入联系地址"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model.trim="model.note" type="textarea" autosize placeholder="请输入"/>
      </el-form-item>
      <div class="editTitle" style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
        <span>供应商合同
          <el-button
              v-if="!disabled"
              type="primary"
              size="small"
              icon="el-icon-plus"
              style="margin-left: 10px"
              @click="handleContractAdd">新建
          </el-button></span>
      </div>
      <el-table border :data="model.contractList" style="margin-top:10px">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column align="center" label="合同编号" width="440">
          <template slot-scope="scope">
            <el-input v-model="scope.row.contractNo" size="small" :disabled="disabled" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column v-if="!disabled" align="center" label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="handleContractDelete(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "SupplierManageEdit",
    components: {},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        model: {
          pkid: "",
          no: "",
          name: "",
          shortCode: "",
          shortName: "",
          outerNO: "",
          contact: "",
          mobile: "",
          postCode: "",
          address: "",
          bank: "",
          vATNO: "",
          vATNAME: "",
          accounts: "",
          note: "",
          contractList: [],
        },
        ruleValidate: {
          name: { required: true, message: "不能为空", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.getData(row.pkid);
        } else {
          this.getNode();
        }
      },
      getData(pkid) {
        this.$http.get("basic", `supplierInfoes/${pkid}`).then((res) => {
          console.log(res);
          if (res.success) {
            if (!res.data.contractList) {
              res.data.contractList = [];
            }
            this.model = Object.assign(this.model, res.data);
          }
        });
      },
      getNode() {
        this.$http.get("basic", "supplierInfoes/selectNo").then((resp) => {
          if (resp.success) {
            this.model.no = resp.data;
          }
        });
      },

      handleSubmit() {
        if (this.model.pkid > 0) {
          this.handleSubmitPut();
        } else {
          this.handleSubmitPost();
        }
      },
      handleSubmitPut() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "supplierInfoes", this.model)
              .then((resp) => {
                if (resp.success) {
                  this.saveContractList();
                } else {
                  this.submitLoading = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitPost() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "supplierInfoes", this.model)
              .then((resp) => {
                if (resp.success) {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                } else {
                  this.submitLoading = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      saveContractList() {
        if (!this.model.contractList || this.model.contractList.length === 0) {
          this.submitLoading = false;
          this.dialogVisible = false;
          this.$emit("save-success");
          this.$message.success("保存成功");
          return;
        }
        this.$http
          .post("basic", `supplierInfoes/batchSaveContract/${this.model.pkid}`, this.model.contractList)
          .then((resp) => {
            this.submitLoading = false;
            this.dialogVisible = false;
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("保存成功");
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      handleContractAdd() {
        if (!this.model.contractList) {
          this.$set(this.model, "contractList", []);
        }
        this.model.contractList.push({
          contractNo: "",
          contractName: "",
          contractAmount: "",
          signDate: "",
          startDate: "",
          endDate: "",
          status: "",
        });
      },
      handleContractDelete(index) {
        this.model.contractList.splice(index, 1);
        this.$message.success("删除成功");
      },
    },
  };
</script>

<style lang="scss" scoped></style>
